function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 10C0 4.48421 4.48421 0 10 0C15.5158 0 20 4.48421 20 10C20 15.5158 15.5158 20 10 20C4.48421 20 0 15.5158 0 10ZM1.55789 10C1.55789 14.6526 5.34737 18.4421 10 18.4421C14.6526 18.4421 18.4421 14.6526 18.4421 10C18.4421 5.34737 14.6526 1.55789 10 1.55789C5.34737 1.55789 1.55789 5.34737 1.55789 10ZM8.46318 6.23154L13.3263 9.47365C13.7053 9.72628 13.7053 10.2737 13.3263 10.5263L8.46318 13.7684C8.06318 14.0421 7.49476 13.7473 7.49476 13.2421V6.75786C7.49476 6.2526 8.04213 5.95786 8.46318 6.23154Z",
  fill: "currentColor"
});

function SvgPlayCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircle);
export default __webpack_public_path__ + "static/media/PlayCircle.3238e84a.svg";
export { ForwardRef as ReactComponent };